<template>
    <v-layout class="manage-feature-event">
        <v-flex xs12 mb-3 v-if="showFeatureEvents">
            <v-btn flat
                   class="manage-feature-event__add-new"
                   data-qe-id="manage-feature-event_btn"
                   @click="changeComponent(communityCommonConstant.featureEvent.componentNames.featureEventList)"
                   id="manage_feature_item">
                {{communityCommonConstant.featureEvent.MANAGE_FEATURE_ITEMS}} 
            </v-btn>
        </v-flex>
        <v-flex xs12 mb-3 v-else>
            <v-btn flat
                   class="manage-feature-event__add-new"
                   data-qe-id="manage-feature-event_add-new_btn"
                   @click="changeComponent(communityCommonConstant.featureEvent.componentNames.createFeatureEvent)"
                   id="add_new_feature_item">
                {{communityCommonConstant.featureEvent.ADD_FEATURE_ITEM}} 
            </v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
    import { communityCommonConstant } from "../communityCommon.constant";

    export default {
        name: 'ManageFeatureEvent',
        data() {
            return {
                communityCommonConstant,
            };
        },
        props: {
            featureItem: {
                type: Object,
                required: true,
            },
            changeComponent: {
                type: Function,
            },
        },
        computed: {
            showFeatureEvents() {
                return !!this.featureItem.eventList.length;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import "../../../common/styles/_responsive.scss";

    .manage-feature-event {
        &__add-new {
            width: 100%;
            margin: 0;
            font-size: 16px;
            padding: 10px;
            font-weight: 600;
            color: $ypo-cta;
            border: 1px solid $ypo-medium-gray;
            border-radius: 4px;
            height: auto;

            @include breakpoint(xs) {
                margin-top: 15px;
            }
        }
    }
</style>
